import Head from 'next/head';

/**
 * Meta tags to prevent search engine indexing and caching
 * Used for password-protected pages
 */
export default function NoIndexMetaTags() {
	return (
		<Head>
			<meta name="robots" content="noindex, nofollow, noarchive, nosnippet, nocache" />
			<meta name="googlebot" content="noindex, nofollow, noarchive, nosnippet, nocache" />
			<meta name="bingbot" content="noindex, nofollow, noarchive, nosnippet, nocache" />
			<meta httpEquiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
			<meta httpEquiv="Pragma" content="no-cache" />
			<meta httpEquiv="Expires" content="0" />
		</Head>
	);
}
